/**
 * Requires confirmation when a move can affect inherited access or organization.
 *
 * Moving an item changes lineage, not just presentation. The warning makes that
 * security consequence explicit before the backend revalidates source and
 * destination permissions.
 */
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from '@/components/ui'
import type { VaultDragPayload } from '../lib/format'

interface VaultMoveConfirmationProps {
  move: { payload: VaultDragPayload; targetId: string } | null
  onCancel: () => void
  onConfirm: (payload: VaultDragPayload, targetId: string) => void
}

export function VaultMoveConfirmation({
  move,
  onCancel,
  onConfirm,
}: VaultMoveConfirmationProps) {
  return (
    <AlertDialog open={move !== null} onOpenChange={(open) => { if (!open) onCancel() }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Move changes who has access</AlertDialogTitle>
          <AlertDialogDescription>
            Moving “{move?.payload.name}” to this folder changes the collaborators it
            inherits. People may gain or lose access.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <Button onClick={() => {
            if (move) onConfirm(move.payload, move.targetId)
          }}>
            Move anyway
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
